import * as React from 'react';
import { InvoiceTotals } from "../../../../models/accounting/invoices/invoice-totals";
import { formatCurrency } from '../../../../utils/currency-formatter';

// #region Component Props

interface IProps {
    summary     : InvoiceTotals;
    totalLabel  : string;
}

// #endregion

export const InvoiceSummaryDisplay = (props:IProps) => (

        <React.Fragment>
            <div className="row align-items-center invoice-summary-display">
                <div className="col">
                    <span className="summary-label">{ props.totalLabel }</span>
                    <br />
                    <span className="summary-value total">
                        {
                            props.summary ? formatCurrency(props.summary.total) : formatCurrency(0)
                        }
                    </span>
                </div>

                <div className="col-auto">
                    <span className="operator"> = </span>
                </div>

                <div className="col">
                    <span className="summary-label">SubTotal</span>
                    <br />
                    <span className="summary-value">
                        {
                            props.summary ? formatCurrency(props.summary.subtotal) : formatCurrency(0) 
                        }
                    </span>
                </div>

                <div className="col-auto">
                    <span className="operator"> + </span>
                </div>

                <div className="col">
                    <span className="summary-label">Freight</span>
                    <br />
                    <span className="summary-value">
                        {
                            props.summary ? formatCurrency(props.summary.freight) : formatCurrency(0)
                        }
                    </span>
                </div>
            {
                props.summary.fuelSurcharge > 0 ? <div className="col-auto">
                    <span className="operator"> + </span>
                </div> : null
            }
            {
                props.summary.fuelSurcharge > 0 ? <div className="col">
                    <span className="summary-label">Fuel Surcharge</span>
                    <br />
                    <span className="summary-value">
                        {
                            props.summary ? formatCurrency(props.summary.fuelSurcharge) : formatCurrency(0)
                        }
                    </span>
                </div> : null
            }
            {
                props.summary.fees > 0 ? <div className="col-auto">
                <span className="operator"> + </span>
                </div> : null
            }
            {
                props.summary.fees > 0 ? <div className="col">
                    <span className="summary-label">Tariffs</span>
                    <br />
                    <span className="summary-value">
                        {
                            props.summary ? formatCurrency(props.summary.fees) : formatCurrency(0)
                        }
                    </span>
                </div> : null
            }

                <div className="col-auto">
                    <span className="operator"> + </span>
                </div>
                
                <div className="col">
                    <span className="summary-label">Tax</span>
                    <br />
                    <span className="summary-value">
                        {
                            props.summary ? formatCurrency(props.summary.tax) : formatCurrency(0)
                        }
                    </span>
                </div>

            </div>
            <div className="row">
                <div className="col">
                    <hr className="" />
                </div>
            </div>
    </React.Fragment>
);
